<template>
<div>
            <app-header></app-header>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Connexion</h1>
                  <p class="text-muted">Connectez vous à votre espace</p>
                   <el-alert
                    title="Erreur de connexion"
                    type="error"
                    v-if="loginError">
                  </el-alert><br>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="email" autocomplete="username email"  v-model="credentials.email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Mot de Passe" autocomplete="current-password"  v-model="credentials.password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <el-button type="primary" :loading="logging" @click="onlogin(credentials)">Se connecter</el-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" @click="$router.push('forgot-password')" class="px-0">Mot de passe oublié ?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Inscription</h2>
                  <p>Vous n'avez pas encore d'espace fournisseur ? Inscrivez vous pour soumettre votre dossier</p>
                  <b-button @click="goToRegister()" variant="primary" class="active mt-3">S'inscrire</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import AppHeader from '../../containers/AppHeader'

export default {
  name: 'Login',
  components:{
    AppHeader
  },

  data: function() {
    return {
      credentials:{
        email:'',
        password:'',
      },
      logging:false
    }
  },
  methods:{
    ...mapActions([
      'login'
    ]),
    re_render(){
      console.log('from Login Rerender')
    },
    goToRegister(){
      this.$router.push('register')
    },
    onlogin(credentials){
    // this.$store.dispatch('login',credentials)/*. then(resp=>{
    //   console.log('boomLogin')
    // }).catch(err=>{
    //   this.loginError = true
    //   console.log('boom')
    // }); */    
    this.logging = true
    this.login(credentials).then(resp=>{
      console.log('loginOK')
      this.logging = false
      this.$router.push({name:'Dashboard'})
      // this.$router.go()
      // window.location.reload()
    })
  },
  
  },
  computed:{
    ...mapState({
      loginError:state=>state.auth.loginError,
      connecting:state=>state.auth.connecting
    })
  },
  mounted(){
    console.log('loginError',this.loginError)
    console.log('connecting',this.connecting)
    // window.location.reload()
  },
}
</script>

<style scoped>
  .menu-item{
    padding-right:20px ;
  }
</style>

